import React from "react";
import {
  Box,
  Paper,
  Tab,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import "./MyJobs.css";
import IndividualJobActivity from "./IndividualJobActivity";
const MyJobs = () => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#05131B",
      color: "#94A3B8",
      borderBottom: "0px",
      "&:first-of-type": {
        borderRadius: "16px 0px 0px 16px",
      },
      "&:last-of-type": {
        borderRadius: "0px 16px 16px 0px",
      },
    },

    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      color: theme.palette.common.white,
      borderBottom: "0px",
    },
  }));
  const StyledTableRow = styled(TableRow)(({ theme }) => ({}));
  return (
    <>
      <Box className="my-job-container">
        <Typography className="font-28">Manage Jobs</Typography>

        <Box>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label="Active"
                  className={value === 0 ? "st-active" : "st-inactive"}
                  {...a11yProps(0)}
                />
                <Tab
                  label="Pending"
                  className={value === 1 ? "st-active" : "st-inactive"}
                  {...a11yProps(1)}
                />
                <Tab label="Missing Details"  className={value === 2 ? "st-active" : "st-inactive"} {...a11yProps(2)} />
                <Tab label="Delivered"  className={value === 3 ? "st-active" : "st-inactive"} {...a11yProps(3)} />
                <Tab label="Completed"  className={value === 4 ? "st-active" : "st-inactive"} {...a11yProps(4)} />
                <Tab label="Cancelled"  className={value === 5 ? "st-active" : "st-inactive"} {...a11yProps(5)} />
                <Tab label="All"  className={value === 6 ? "st-active" : "st-inactive"} {...a11yProps(6)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Box>
                <TableContainer component={Paper} className="TableContainer">
                  <Typography className="font-22 text-white" mb={2}>
                    Active Orders
                  </Typography>
                  <Table aria-label="customized table">
                    <TableHead className="TableHeader">
                      <TableRow>
                        <StyledTableCell>Project</StyledTableCell>
                        <StyledTableCell align="left">
                          Order Date
                        </StyledTableCell>
                        <StyledTableCell align="center">Due On</StyledTableCell>
                        <StyledTableCell align="left">Total</StyledTableCell>
                        <StyledTableCell align="center">Status</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody></TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              Item Two
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              Item Three
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              Item four
            </CustomTabPanel>
            <CustomTabPanel value={value} index={4}>
              Item five
            </CustomTabPanel>
            <CustomTabPanel value={value} index={5}>
              Item six
            </CustomTabPanel>
            <CustomTabPanel value={value} index={6}>
              Item seven
            </CustomTabPanel>
          </Box>
        </Box>
      </Box>
      <Box>
        <IndividualJobActivity />
      </Box>
    </>
  );
};

export default MyJobs;
